import React from "react";

import Box from "@mui/material/Box";
import MenuItem from "@mui/material/MenuItem";
import Typography from "@mui/material/Typography";
import ListSubheader from "@mui/material/ListSubheader";
import InputAdornment from "@mui/material/InputAdornment";

import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

import { Input } from "@src/components/Input/Input";
import LocationIcon from "@src/assets/icons/location.png";
import { ReactComponent as SearchIcon } from "@src/assets/icons/search.svg";
import { setCurrentLocation } from "@src/store/app_manager/actionCreators";
import { TextFieldSelect } from "@src/components/TextFieldSelect/TexttFieldSelect";
import { ReactComponent as LocationDisabledIcon } from "@src/assets/icons/LocationIcon.svg";
import { selectCurrentLocation, selectRestaurantGroupLocations, } from "@src/store/app_manager/selector";

export const LocationSelect: React.FC = () => {
  const dispatch = useDispatch();

  const full_url = useLocation();
  const navigate = useNavigate();
  const currLocation = useSelector(selectCurrentLocation);
  const restaurantGroupLocations = useSelector(selectRestaurantGroupLocations);

  const inputRef = React.useRef<HTMLInputElement>(null);
  const [search, setSearch] = React.useState("");
  const [restaurantId, setRestaurantId] = React.useState("");

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>): void => {

    setSearch(e.target.value);
  };

  const handleRestChange = (e: any): void => {

    const url_arr = location.pathname.split("/");

    dispatch(setCurrentLocation(e.target.value));

    setRestaurantId(e.target.value);

    if (url_arr.indexOf("configure") !== -1) {
      navigate("/app/menu");
    }
  };

  React.useEffect(() => {

    setRestaurantId(currLocation);
  }, [currLocation]);

  const filterLocations = React.useMemo(() => {
    if (restaurantGroupLocations?.length) {
      return restaurantGroupLocations.filter((item: any) =>
        item.restaurant_name.toLowerCase().includes(search.toLocaleLowerCase())
      );
    }

    return [];
  }, [search, restaurantGroupLocations]);

  const fullUrlArr = full_url.pathname.split("/");

  const restaurant_disabled =
    fullUrlArr[fullUrlArr.length - 1] === "time-settings" ||
    fullUrlArr[fullUrlArr.length - 1] === "pos-settings";

  return (
    <Box p="10px 40px">
      <TextFieldSelect
        select
        disabled={restaurant_disabled}
        value={restaurantId}
        onChange={handleRestChange}
        sx={{
          position: "relative",
          "& .MuiPaper-root": {
            borderRadius: "20px"
          }
        }}

        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              {restaurant_disabled ? (
                <LocationDisabledIcon />
              ) : (
                <img src={LocationIcon} width="14px" height="20px" />
              )}
            </InputAdornment>),
        }}
      >
        <ListSubheader
          style={{
            margin: 0,
            padding: 0,
            position: "sticky",
            top: 0,
            left: 0,
            width: "100%"
          }}
        >
          <Input
            ref={inputRef}
            size="small"
            fullWidth
            autoFocus
            placeholder="Search"
            value={search}
            onChange={handleSearch}
            inputSize="l"
            sx={{ margin: 0, padding: "0 3px", borderRadius: "5px" }}
            startAdornment={
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            }
            onKeyDown={(e) => {
              if (e.key !== "Escape") {
                e.stopPropagation();
              }
            }}
          />
        </ListSubheader>

        <MenuItem key={"all"} value="all">
          Все
        </MenuItem>

        {!restaurant_disabled ? (
          filterLocations?.map((location: any) => (
            <MenuItem
              key={location.restaurant_id}
              value={location.restaurant_id}
            >
              {location.restaurant_name}
            </MenuItem>
          ))
        ) : (
          <Typography textAlign="center">Пусто</Typography>
        )}
      </TextFieldSelect>
    </Box>
  );
};